const translations = {
	title: "Suivi du dossier",
	rto_signature: "E-signature convention RTO",
	subscription_signature: "E-signature dossier de souscription",
	send_signed_documents: "Transmettre le dossier signé à la société de gestion",
	validation: "Validation du dossier par la société de gestion",
	waiting_signature: "{{name}} : En attente de signature",
	signed: "{{name}} : Signé",
	declined: "{{name}} : Refusé",
	expired: "Demande de signature expiré",
	waiting_transfer_sg: "En cours de transmission",
	file_transmited: "Dossier transmis",
	waiting: "En attente",
	file_validated: "Dossier validé",
	validate: "Valider",
	transmit: "Transmettre",
	close: "Fermer",
	resend: "Renvoyer une demande",
	resend_document_modal: {
		title: "Renvoyer une demande",
		description: "Les clients ayant déjà signé devront signer à nouveau si vous renvoyez cette demande.",
		cancel: "Annuler",
		confirm: "Renvoyer une demande",
		transfered: "Transmis à la société de gestion avec succès",
		success: "Demande envoyée avec succès !",
	},
	// Private equity : la société de gestion signe le contrat après l'investisseur, sa signature valide le dossier.
	counter_signature: {
		transmit_title: "Transmettre le dossier",
		signature_title: "Signature de la société de gestion",
		canceled: "Demande de signature annulée",
		no_request: "Aucune demande de signature en cours",
		change_signatory: "Renvoyer ou changer de signataire",
		request_signature: "Demander la signature",
		transferred: "Dossier transmis pour signature à {{name}}",
	},
};

export default translations;
